<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="fuelbalance_first_row_right_section co_dealer"
          style="flex: 0 0 96.5%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner" style="width: 100%; height: 150px">
            <div class="row align-items-center section__row">
              <div class="col-md-7 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.endOfDayReport.title") }} - {{ operatingPeriod }}
                </h3>
              </div>
              <div class="col-md-3 section___column_2">
                <div class="align-items-center">
                  <div class>
                    <div class="drop_down_section mt-2 mr-2">
                      <div class="drop_down_div align-items-center">
                        <!-- <vue-ctk-date-time-picker
                          v-model="dateRange"
                          :max-date="maxDate"
                          :onlyDate="true"
                          :autoClose="true"
                          :locale="this.$root.$i18n.locale"
                          :color="$store.getters.getDatePickerColor"
                          format="DDMMYYYY"
                          formatted="DD/MM/YYYY"
                          :label="$t('text.calendar.selectDate')"
                        /> -->
                        <vue-ctk-date-time-picker
                          v-model="dateRange"
                          :max-date="maxDate"
                          :range="true"
                          :autoClose="true"
                          :locale="this.$root.$i18n.locale"
                          :custom-shortcuts="customShortcuts"
                          color="#4b2d73"
                          format="DDMMYYYY"
                          formatted="DD/MM/YYYY"
                          :label="$t('text.sendReport.dateRange')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="products_summary__wrapper mt-3 pb-3">
        <div class="row" style="margin-right: 0px">
          <!-- PMS CARD -->
          <div class="col-md-3" style="padding-right: 0px !important">
            <div
              class="pms_product_summary__wrapper"
              :class="
                !availableProducts.includes(
                  countryProducts.productsLower.product1
                )
                  ? 'disabledCursor'
                  : null
              "
            >
              <!-- HEADER -->
              <div
                class="pms__product_header"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <p
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product1
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  <span>
                    <img
                      src="@/assets/img/drop-of-liquid.png"
                      width="25px"
                      class="mr-3"
                    />
                  </span>
                  {{ countryProducts.products.product1 }}
                </p>
              </div>

              <!-- TOTAL VOLUME SOLD -->
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalVolumeSold") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(pmsSummary.volume) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(pmsSummary.volume) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <!-- TOTAL RTT -->
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalRtt") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(pmsSummary.rtt) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(pmsSummary.rtt) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <!-- TOTAL SALES -->
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ $n(pmsSummary.amount, 'currency') }} -->
                    <span v-if="!pumpSalesLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(pmsSummary.amount) }}
                      <!-- {{ $n(pmsSummary.amount, 'currency') }}  -->
                      <!-- {{$t('text.units.litres')}} -->
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <!-- TOTAL CASH SALES -->
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalCashSale") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}

                      {{
                        decimalThousand(
                          newTableData.pms
                            ? pmsSummary.amount -
                                newTableData.pms.eSalesTotalAmount
                            : 0
                        )
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                    <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->
                  </h4>
                </div>
              </div>

              <!-- OFFLINE SALES -->
              <div
                v-if="userDetails.roles.includes('SupportAdmin')"
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totOfflineSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        newTableData.pms
                          ? decimalThousand(newTableData.pms.offlineSales)
                          : decimalThousand(0)
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                    <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->
                  </h4>
                </div>
              </div>

              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.epumpSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ $n(pmsVoucher.epump, 'currency') }} -->
                    <span v-if="!posVoucherLoader">
                      {{ branch ? branch.currencyCode : "" }}

                      <!-- CHECK IF ESALES EXIST -->

                      <span v-if="newTableData.pms">
                        {{
                          decimalThousand(newTableData.pms.eSalesTotalAmount)
                        }}
                      </span>
                      <span v-else>
                        {{ decimalThousand(0) }}
                      </span>

                      <!-- {{ $n(pmsVoucher.epump, 'currency') }} -->
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <!-- <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.retainershipSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
             
                    <span v-if="!posVoucherLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(pmsVoucher.retainership) }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div> -->

              <!-- <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    POS Sale
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product1
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span v-if="!posTransactionLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(pmsPosSale) }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posTransactionLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div> -->
            </div>
          </div>

          <!-- AGO CARD -->
          <div class="col-md-3" style="padding-right: 0px !important">
            <div
              class="ago_product_summary__wrapper"
              :class="
                !availableProducts.includes(
                  countryProducts.productsLower.product2
                )
                  ? 'disabledCursor'
                  : null
              "
            >
              <div
                class="ago__product_header"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <p
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product2
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  <span>
                    <img
                      src="@/assets/img/drop-of-liquid.png"
                      width="25px"
                      class="mr-3"
                    />
                  </span>
                  {{ countryProducts.products.product2 }}
                </p>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalVolumeSold") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(agoSummary.volume) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(agoSummary.volume) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalRtt") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(agoSummary.rtt) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader"
                      >{{ decimalThousand(agoSummary.rtt) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- &#8358;
                    {{ decimalThousand(agoSummary.amount) }} -->

                    <!-- {{ $n(agoSummary.amount, 'currency') }} -->
                    <span v-if="!pumpSalesLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(agoSummary.amount) }}
                      <!-- {{ $n(agoSummary.amount, 'currency') }} -->
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalCashSale") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((agoSummary.amount - (agoVoucher.epump + agoVoucher.retainership +  agoSummary.rttAmount + agoPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        decimalThousand(
                          newTableData.ago
                            ? agoSummary.amount -
                                newTableData.ago.eSalesTotalAmount
                            : 0
                        )
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                    <!-- {{ $n((agoSummary.amount - (agoVoucher.epump + agoVoucher.retainership +  agoSummary.rttAmount + agoPosSale)), 'currency') }} -->
                  </h4>
                </div>
              </div>

              <!-- OFFLINE SALES -->
              <div
                v-if="userDetails.roles.includes('SupportAdmin')"
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product1
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totOfflineSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        newTableData.ago
                          ? decimalThousand(newTableData.ago.offlineSales)
                          : decimalThousand(0)
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                    <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->
                  </h4>
                </div>
              </div>

              <!-- TOTAL ESALES -->
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product2
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.epumpSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product2
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span v-if="!posVoucherLoader">
                      {{ branch ? branch.currencyCode : "" }}

                      <!-- CHECK IF ESALES EXIST -->

                      <span v-if="newTableData.ago">
                        {{
                          decimalThousand(newTableData.ago.eSalesTotalAmount)
                        }}
                      </span>
                      <span v-else>
                        {{ decimalThousand(0) }}
                      </span>

                      <!-- {{ $n(agoVoucher.epump, 'currency') }} -->
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <!-- DPK CARD -->
          <div class="col-md-3" style="padding-right: 0px !important">
            <div
              class="dpk_product_summary__wrapper"
              :class="
                !availableProducts.includes(
                  countryProducts.productsLower.product3
                )
                  ? 'disabledCursor'
                  : null
              "
            >
              <div
                class="dpk__product_header"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <p
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product3
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  <span>
                    <img
                      src="@/assets/img/drop-of-liquid.png"
                      width="25px"
                      class="mr-3"
                    />
                  </span>
                  {{ countryProducts.products.product3 }}
                </p>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalVolumeSold") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(dpkSummary.volume) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(dpkSummary.volume) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalRtt") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(dpkSummary.rtt) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(dpkSummary.rtt) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- &#8358;
                    {{ decimalThousand(dpkSummary.amount) }} -->

                    <!-- {{ $n(dpkSummary.amount, 'currency') }} -->
                    <span v-if="!pumpSalesLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(dpkSummary.amount) }}
                      <!-- {{ $n(dpkSummary.amount, 'currency') }} -->
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalCashSale") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        decimalThousand(
                          newTableData.dpk
                            ? dpkSummary.amount -
                                newTableData.dpk.eSalesTotalAmount
                            : 0
                        )
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <!-- OFFLINE SALES -->
              <div
                v-if="userDetails.roles.includes('SupportAdmin')"
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totOfflineSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        newTableData.dpk
                          ? decimalThousand(newTableData.dpk.offlineSales)
                          : decimalThousand(0)
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                    <!-- {{ $n((pmsSummary.amount - (pmsVoucher.epump + pmsVoucher.retainership +  pmsSummary.rttAmount + pmsPosSale)), 'currency') }} -->
                  </h4>
                </div>
              </div>

              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product3
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.epumpSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product3
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span v-if="!posVoucherLoader">
                      {{ branch ? branch.currencyCode : "" }}

                      <!-- CHECK IF ESALES EXIST -->

                      <span v-if="newTableData.dpk">
                        {{
                          decimalThousand(newTableData.dpk.eSalesTotalAmount)
                        }}
                      </span>
                      <span v-else>
                        {{ decimalThousand(0) }}
                      </span>
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <!-- LPG CARD -->
          <div class="col-md-3" style="padding-right: 0px !important">
            <div
              class="dpk_product_summary__wrapper"
              :class="
                !availableProducts.includes(
                  countryProducts.productsLower.product4
                )
                  ? 'disabledCursor'
                  : null
              "
            >
              <div
                class="lpg__product_header"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <p
                  :class="
                    !availableProducts.includes(
                      countryProducts.productsLower.product4
                    )
                      ? 'disabledColor'
                      : null
                  "
                >
                  <span>
                    <img
                      src="@/assets/img/drop-of-liquid.png"
                      width="25px"
                      class="mr-3"
                    />
                  </span>
                  {{ countryProducts.products.product4 }}
                </p>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalVolumeSold") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(lpgSummary.volume) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalRtt") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ decimalThousand(lpgSummary.rtt) }} {{$t('text.units.litres')}} -->
                    <span v-if="!pumpSalesLoader">
                      {{ decimalThousand(lpgSummary.rtt) }}
                      {{ $t("text.units.litres") }}</span
                    >
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span v-if="!pumpSalesLoader">
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(lpgSummary.amount) }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="pumpSalesLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totalCashSale") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ $n((lpgSummary.amount - (lpgVoucher.epump + lpgVoucher.retainership + lpgSummary.rttAmount + lpgPosSale)), 'currency') }} -->
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      <!-- {{ $n((lpgSummary.amount - (lpgVoucher.epump + lpgVoucher.retainership + lpgSummary.rttAmount + lpgPosSale)), 'currency') }} -->

                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        decimalThousand(
                          newTableData.lpg
                            ? lpgSummary.amount -
                                newTableData.lpg.eSalesTotalAmount
                            : 0
                        )
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <!-- OFFLINE SALES -->
              <div
                v-if="userDetails.roles.includes('SupportAdmin')"
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.totOfflineSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <span
                      v-if="
                        !pumpSalesLoader &&
                        !posVoucherLoader &&
                        !posTransactionLoader
                      "
                    >
                      {{ branch ? branch.currencyCode : "" }}
                      {{
                        newTableData.lpg
                          ? decimalThousand(newTableData.lpg.offlineSales)
                          : decimalThousand(0)
                      }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="
                        pumpSalesLoader ||
                        posVoucherLoader ||
                        posTransactionLoader
                      "
                    ></pulse-loader>
                  </h4>
                </div>
              </div>

              <div
                class="clearfix volume_info"
                :class="
                  !availableProducts.includes(
                    countryProducts.productsLower.product4
                  )
                    ? 'hideCalButton'
                    : null
                "
              >
                <div class="left_div">
                  <h4
                    class="vol_sold"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    {{ $t("text.endOfDayReport.epumpSales") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="litres"
                    :class="
                      !availableProducts.includes(
                        countryProducts.productsLower.product4
                      )
                        ? 'disabledColor'
                        : null
                    "
                  >
                    <!-- {{ $n(lpgVoucher.epump, 'currency') }} -->
                    <span v-if="!posVoucherLoader">
                      <!-- {{ $n(lpgVoucher.epump, 'currency') }} -->
                      {{ branch ? branch.currencyCode : "" }}

                      <!-- CHECK IF ESALES EXIST -->

                      <span v-if="newTableData.lpg">
                        {{
                          decimalThousand(newTableData.lpg.eSalesTotalAmount)
                        }}
                      </span>
                      <span v-else>
                        {{ decimalThousand(0) }}
                      </span>
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="account_summary mt-3">
        <h3 class="account_summary_header">
          <img src="@/assets/img/accounting.svg" class="mr-2" />
          {{ $t("text.endOfDayReport.accountSummary") }}
        </h3>
        <div class style="margin: 0 auto; width: 97.7%">
          <div class="row">
            <div class="col-md-8 border__div">
              <div
                class="row border__div"
                style="border-bottom: 1px solid rgb(226, 206, 255)"
              >
                <div class="col-md-6">
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashSales") }}
                      </h6>
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <!-- {{ $n((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )), 'currency') }} -->
                        <span
                          v-if="
                            !posTransactionLoader &&
                            !posVoucherLoader &&
                            !pumpSalesLoader
                          "
                        >
                          <!-- {{ $n((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )), 'currency') }} -->

                          {{ branch ? branch.currencyCode : "" }}
                          {{
                            decimalThousand(
                              totalSale -
                                (pos_voucher.retainership +
                                  pos_voucher.voucher +
                                  rttAmount +
                                  posValue)
                            )
                          }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="
                            posTransactionLoader ||
                            posVoucherLoader ||
                            pumpSalesLoader
                          "
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashSales") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <span
                          v-if="
                            !posTransactionLoader &&
                            !posVoucherLoader &&
                            !pumpSalesLoader
                          "
                        >
                          <!-- {{ $n((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )), 'currency') }} -->

                          {{ branch ? branch.currencyCode : "" }}
                          {{
                            decimalThousand(
                              totalSale -
                                (pos_voucher.retainership +
                                  pos_voucher.voucher +
                                  rttAmount +
                                  posValue)
                            )
                          }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="
                            posTransactionLoader ||
                            posVoucherLoader ||
                            pumpSalesLoader
                          "
                        ></pulse-loader>
                        <!-- {{ $n((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )), 'currency') }} -->
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.epumpSales") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <!-- {{ $n((pos_voucher.voucher), 'currency') }} -->
                        <span v-if="!posVoucherLoader">
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(newTableData.allEsales) }}
                          <!-- {{ $n((pos_voucher.voucher), 'currency') }} -->
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.epumpSales") }}
                      </h6>
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <!-- {{ $n((pos_voucher.voucher), 'currency') }} -->
                        <span v-if="!posVoucherLoader">
                          {{ $n(pos_voucher.voucher, "currency") }}
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(pos_voucher.voucher) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row mt-3 border__div"
                style="border-bottom: 1px solid rgb(226, 206, 255)"
              >
                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashToBank") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <span v-if="!cashToBankLoader">
                          <!-- {{ $n(cashToBank, 'currency') }} -->
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(cashToBank) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="cashToBankLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashToBank") }}
                      </h6>
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <span v-if="!cashToBankLoader">
                          <!-- {{ $n(cashToBank, 'currency') }} -->
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(cashToBank) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="cashToBankLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.returnToTank") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <!-- {{ $n(rttAmount, 'currency') }} -->
                        <span v-if="!posVoucherLoader">
                          <!-- {{ $n(rttAmount, 'currency') }} -->
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(rttAmount) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.returnToTank") }}
                      </h6>
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <!-- {{ $n(rttAmount, 'currency') }} -->
                        <span v-if="!posVoucherLoader">
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(rttAmount) }}
                          <!-- {{ $n(rttAmount, 'currency') }} -->
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row mt-3 border__div"
                style="border-bottom: 1px solid rgb(226, 206, 255)"
              >
                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.expense") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <!-- &#8358; {{ decimalThousand(expense) }} -->
                        <!-- {{ $n(expense, 'currency') }} -->
                        <span v-if="!expenseLoader">
                          <!-- {{ $n(expense, 'currency') }} -->
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(expense) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="expenseLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.expense") }}
                      </h6>
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <!-- &#8358; {{ decimalThousand(expense) }} -->
                        <!-- {{ $n(expense, 'currency') }} -->
                        <span v-if="!expenseLoader">
                          <!-- {{ $n(expense, 'currency') }} -->
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(expense) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="expenseLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img
                          src="@/assets/img/payment-method.png"
                          width="50%"
                        />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashAtHand") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <!-- &#8358;
                          {{ decimalThousand(
                            (totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount)) - (cashToBank) - (expense) 
                          )
                        }} -->
                        <span
                          v-if="
                            !posTransactionLoader &&
                            !posVoucherLoader &&
                            !pumpSalesLoader &&
                            !expenseLoader
                          "
                        >
                          <!-- {{ $n(((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )) - (cashToBank) - (expense)), 'currency') }} -->

                          {{ branch ? branch.currencyCode : "" }}
                          {{
                            decimalThousand(
                              totalSale -
                                (pos_voucher.retainership +
                                  pos_voucher.voucher +
                                  rttAmount +
                                  posValue) -
                                cashToBank -
                                expense
                            )
                          }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="
                            posTransactionLoader ||
                            posVoucherLoader ||
                            pumpSalesLoader ||
                            expenseLoader
                          "
                        ></pulse-loader>
                        <!-- {{ $n(((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )) - (cashToBank) - (expense)), 'currency') }} -->
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.cashAtHand") }}
                      </h6>
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <!-- {{ decimalThousand(
                            (totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount)) - (cashToBank) - (expense) 
                          )
                        }} -->
                        <span
                          v-if="
                            !posTransactionLoader &&
                            !posVoucherLoader &&
                            !pumpSalesLoader &&
                            !expenseLoader
                          "
                        >
                          <!-- {{ $n(((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )) - (cashToBank) - (expense)), 'currency') }} -->

                          {{ branch ? branch.currencyCode : "" }}
                          {{
                            decimalThousand(
                              totalSale -
                                (pos_voucher.retainership +
                                  pos_voucher.voucher +
                                  rttAmount +
                                  posValue) -
                                cashToBank -
                                expense
                            )
                          }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="
                            posTransactionLoader ||
                            posVoucherLoader ||
                            pumpSalesLoader ||
                            expenseLoader
                          "
                        ></pulse-loader>
                        <!-- {{ $n(((totalSale - (pos_voucher.retainership + pos_voucher.voucher + rttAmount + posValue )) - (cashToBank) - (expense)), 'currency') }} -->
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RETAINER AND POS ROW -->

              <div
                class="row mt-3 border__div"
                style="border-bottom: 1px solid rgb(226, 206, 255)"
              >
                <!-- <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.retainershipSales") }}
                      </h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        <span v-if="!posVoucherLoader">
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(pos_voucher.retainership) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">
                        {{ $t("text.endOfDayReport.retainershipSales") }}
                      </h6>
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <span v-if="!posVoucherLoader">
                          {{ decimalThousand(pos_voucher.retainership) }}</span
                        >
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div> -->

                <div class="col-md-6">
                  <div class="row web__sales">
                    <div class="col-md-6">
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                      <h6 class="mt-2">{{ $t("text.endOfDayReport.pos") }}</h6>
                    </div>
                    <div class="col-md-6 column__grid">
                      <h4 class="litres">
                        {{ branch ? branch.currencyCode : "" }}
                        {{ decimalThousand(posValue) }}
                      </h4>
                    </div>
                  </div>
                  <div class="clearfix mobile__sales">
                    <div class="left_div">
                      <h6 class="mt-2">{{ $t("text.endOfDayReport.pos") }}</h6>
                      <div class="icon____div">
                        <img src="@/assets/img/share.svg" width="50%" />
                      </div>
                    </div>
                    <div class="right_div">
                      <h4 class="litres">
                        <span v-if="!posVoucherLoader && !posTransactionLoader">
                          {{ branch ? branch.currencyCode : "" }}
                          {{ decimalThousand(posValue) }}
                        </span>
                        <pulse-loader
                          size="15px"
                          v-if="posVoucherLoader || posTransactionLoader"
                        ></pulse-loader>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="total_sales_div showAllContainer">
                <h3 class="total_sales__header">
                  {{ $t("text.endOfDayReport.totalSales") }}
                </h3>
                <div class="icon____div mt-3" style="background: aliceblue">
                  <img src="@/assets/img/accounting.svg" width="50%" />
                </div>
                <div class="mt-3">
                  <h4 class="amount__header">
                    <!-- &#8358; {{ decimalThousand(totalSale) }} -->
                    <!-- {{ $n(totalSale, 'currency') }} -->
                    <span
                      v-if="
                        !posVoucherLoader &&
                        !posTransactionLoader &&
                        !expenseLoader &&
                        !pumpSalesLoader
                      "
                    >
                      <!-- {{ $n(totalSale, 'currency') }} -->
                      {{ branch ? branch.currencyCode : "" }}
                      {{ decimalThousand(totalSale) }}
                    </span>
                    <pulse-loader
                      size="15px"
                      v-if="posVoucherLoader || posTransactionLoader"
                    ></pulse-loader>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ESALES TABLE -->
      <section class="sales__summary__wrapper mt-5">
        <div class="row">
          <div class="col-md-8">
            <div class="sales__summary_wrapper__section">
              <div
                class="sales__summary_wrapper__section_header showAllContainer"
              >
                <p>
                  <span>
                    <img
                      src="@/assets/img/sale.png"
                      width="25px"
                      class="mr-2 ml-2"
                    />
                  </span>
                  {{ $t("text.endOfDayReport.esalesSummary") }}
                </p>
              </div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product1
                          )
                        "
                        >{{ countryProducts.products.product1 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product2
                          )
                        "
                        >{{ countryProducts.products.product2 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product3
                          )
                        "
                        >{{ countryProducts.products.product3 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text" v-if="newTableData.lpg">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product4
                          )
                        "
                        >{{ countryProducts.products.product4 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- POS SALES ROW -->
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.bCashFlow.posSales") }}
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.POSAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.POSAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.POSAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.POSAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>

                  <!-- MOBILE MONEY SALES ROW -->
                  <!-- <tr style="height: 70px">
                    <td class="primary_text">Mobile Money Sales</td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.mobileMoneyAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.mobileMoneyAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.mobileMoneyAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.mobileMoneyAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr> -->

                  <!-- PHONE SALES ROW -->
                  <!-- <tr style="height: 70px">
                    <td class="primary_text">Phone Sales</td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.phoneAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.phoneAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.phoneAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.phoneAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr> -->

                  <!-- CARD SALES ROW -->

                  <tr style="height: 70px">
                    <td class="primary_text">Card Sales</td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.cardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.cardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.cardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.cardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>

                  <!-- REMIS SALES ROW -->
                  <tr style="height: 70px">
                    <td class="primary_text">Remis Sales</td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.remisAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.remisAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.remisAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.remisAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>

                  <!-- RETAINERSHIP SALES ROW -->
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.retainershipSales") }}
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.retainershipAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.retainershipAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.retainershipAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.retainershipAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>

                  <!-- SWIPE CARD SALES ROW -->
                  <!-- <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.swipeCardSales") }}
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.swipeCardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.swipeCardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.swipeCardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.swipeCardAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr> -->

                  <!-- USSD SALES ROW -->
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.ussdSales") }}
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.ussdAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.ussdAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.ussdAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.ussdAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>

                  <!-- VOUCHER SALES ROW -->
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.voucherSales") }}
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.pms">
                          {{
                            decimalThousand(newTableData.pms.voucherAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.ago">
                          {{
                            decimalThousand(newTableData.ago.voucherAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.dpk">
                          {{
                            decimalThousand(newTableData.dpk.voucherAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td v-if="newTableData.lpg">
                      <span v-if="!pumpSalesLoader">
                        <span v-if="newTableData.lpg">
                          {{
                            decimalThousand(newTableData.lpg.voucherAmount)
                          }}</span
                        >
                        <span v-else> {{ decimalThousand(0) }}</span>
                      </span>

                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-4 drivers_block end_of_day_report_chart">
            <div class="highcharts__div" style="background: white; width: 100%">
              <apexchart
                type="donut"
                :options="chartOptions2"
                :series="donutSeries2"
              ></apexchart>
            </div>
          </div>
        </div>
      </section>

      <!-- SALES SUMMARY TABLE -->
      <section class="sales__summary__wrapper mt-5">
        <div class="row">
          <div class="col-md-8">
            <div class="sales__summary_wrapper__section">
              <div
                class="sales__summary_wrapper__section_header showAllContainer"
              >
                <p>
                  <span>
                    <img
                      src="@/assets/img/sale.png"
                      width="25px"
                      class="mr-2 ml-2"
                    />
                  </span>
                  {{ $t("text.endOfDayReport.salesSummary") }}
                </p>
              </div>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product1
                          )
                        "
                        >{{ countryProducts.products.product1 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product2
                          )
                        "
                        >{{ countryProducts.products.product2 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product3
                          )
                        "
                        >{{ countryProducts.products.product3 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                    <th class="primary_text">
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product4
                          )
                        "
                        >{{ countryProducts.products.product4 }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.pumpSales") }}
                    </td>
                    <td>
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product1
                          )
                        "
                        >{{ decimalThousand(pumpSale.pms) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product2
                          )
                        "
                        >{{ decimalThousand(pumpSale.ago) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product3
                          )
                        "
                        >{{ decimalThousand(pumpSale.dpk) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product4
                          )
                        "
                        >{{ decimalThousand(pumpSale.lpg) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.tankSales") }}
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product1
                          )
                        "
                        >{{ decimalThousand(tankSale.pms) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product2
                          )
                        "
                        >{{ decimalThousand(tankSale.ago) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product3
                          )
                        "
                        >{{ decimalThousand(tankSale.dpk) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product4
                          )
                        "
                        >{{ decimalThousand(tankSale.lpg) }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>
                  <tr style="height: 70px">
                    <td class="primary_text">
                      {{ $t("text.endOfDayReport.surplus") }}
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product1
                          )
                        "
                        >{{
                          decimalThousand(pumpSale.pms - tankSale.pms)
                        }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader || pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product2
                          )
                        "
                        >{{
                          decimalThousand(pumpSale.ago - tankSale.ago)
                        }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader || pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product3
                          )
                        "
                        >{{
                          decimalThousand(pumpSale.dpk - tankSale.dpk)
                        }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader || pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                    <td>
                      <span
                        v-if="
                          !tankSalesLoader &&
                          !pumpSalesLoader &&
                          availableProducts.includes(
                            countryProducts.productsLower.product4
                          )
                        "
                        >{{
                          decimalThousand(pumpSale.lpg - tankSale.lpg)
                        }}</span
                      >
                      <pulse-loader
                        size="15px"
                        v-if="tankSalesLoader || pumpSalesLoader"
                      ></pulse-loader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-4 drivers_block end_of_day_report_chart">
            <div class="highcharts__div" style="background: white; width: 100%">
              <apexchart
                type="donut"
                :options="chartOptions"
                :series="donutSeries"
              ></apexchart>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "OurBranches",
  components: {
    MasterLayout,
    Highcharts: Chart,
    PulseLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      // maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      // dateRange: this.startDate,
      // pluginStartDate: this.$moment().format("D-M-YYYY"),
      // startDate: this.$moment().format("MMMM D, YYYY"),

      newTableData: {},
      pmsTotalCashSales: 0,
      agoTotalCashSales: 0,
      lpgTotalCashSales: 0,
      dpkTotalCashSales: 0,
      pumpSalesLoader: true,
      tankSalesLoader: true,
      cashToBankLoader: true,
      posVoucherLoader: true,
      posTransactionLoader: true,
      expenseLoader: true,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      branch: {},
      branchId: null,
      posValue: 0,
      backgroundUrl,
      cardBackgroundUrl,
      availableProducts: [],
      showLoader: false,
      tankSale: { pms: 0, ago: 0, dpk: 0 },
      pumpSale: { pms: 0, ago: 0, dpk: 0 },
      pmsPosSale: 0,
      agoPosSale: 0,
      dpkPosSale: 0,
      lpgPosSale: 0,
      pos_voucher: { voucher: 0, retainership: 0 },
      pmsSummary: { volume: 0, amount: 0, rtt: 0, rttAmount: 0 },
      agoSummary: { volume: 0, amount: 0, rtt: 0, rttAmount: 0 },
      dpkSummary: { volume: 0, amount: 0, rtt: 0, rttAmount: 0 },
      lpgSummary: { volume: 0, amount: 0, rtt: 0, rttAmount: 0 },
      pmsVoucher: { epump: 0, retainership: 0 },
      agoVoucher: { epump: 0, retainership: 0 },
      dpkVoucher: { epump: 0, retainership: 0 },
      lpgVoucher: { epump: 0, retainership: 0 },
      totalSale: 0,
      rttAmount: 0,
      expense: 0,

      cashToBank: 0,
      operatingPeriod: "",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },

      userDetails: JSON.parse(localStorage.getItem("userDetails")),

      // CASH SALES SUMMARY
      donutSeries: [0, 0, 0, 0],
      chartOptions: {
        chart: {
          type: "donut",
          height: "400px",
        },
        title: {
          text: "Sales By Volume",
          align: "center",
          margin: 30,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "18px",
            fontWeight: "400",
          },
        },
        // labels: [this.countryProducts.products.product1, this.countryProducts.products.product2, this.countryProducts.products.product3, this.countryProducts.products.product4],
        colors: ["#13cf2d", "#00aced", "#d8991c", "purple"],
        legend: {
          position: "bottom",
          onItemClick: {
            toggleDataSeries: true,
          },
          fontSize: "12px",
          fontWeight: 600,
          itemMargin: {
            horizontal: 15,
          },
        },
        responsive: [
          {
            options: {
              legend: {
                position: "bottom",
                onItemClick: {
                  toggleDataSeries: true,
                },
              },
            },
          },
        ],
      },

      // ESALES SUMMARY GRAPH
      donutSeries2: [0, 0, 0, 0],
      chartOptions2: {
        chart: {
          type: "donut",
          height: "400px",
        },
        title: {
          text: "Sales By Volume",
          align: "center",
          margin: 30,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "18px",
            fontWeight: "400",
          },
        },
        // labels: [this.countryProducts.products.product1, this.countryProducts.products.product2, this.countryProducts.products.product3, this.countryProducts.products.product4],
        colors: ["#13cf2d", "#00aced", "#d8991c", "purple"],
        legend: {
          position: "bottom",
          onItemClick: {
            toggleDataSeries: true,
          },
          fontSize: "12px",
          fontWeight: 600,
          itemMargin: {
            horizontal: 15,
          },
        },
        responsive: [
          {
            options: {
              legend: {
                position: "bottom",
                onItemClick: {
                  toggleDataSeries: true,
                },
              },
            },
          },
        ],
      },
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getAllReports();
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.getAllReports();
            let bankTrans = JSON.parse(
              localStorage.getItem("bankTransactions" || "[]")
            );
            // this.cashToBank = bankTrans.reduce((acc, curr) => {
            //   return acc + curr.amount;
            // }, 0);

            let expenses = JSON.parse(localStorage.getItem("expenses" || "[]"));
            // this.expense = expenses.reduce((acc, curr) => {
            //   return acc + curr.amount;
            // }, 0);
          }
        }
      }
    },

    // dateRange: function(newDate) {
    //   if (newDate && this.branchId) {
    //     this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
    //       "MMMM D, YYYY"
    //     );
    //     this.cashToBank = 0
    //     this.getAllReports();
    //   }
    // }
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.cashToBank = 0;
        this.getAllReports();
      }
    },
  },

  created() {
    document.title = "End of day report:: Epump Retail Outlet";
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `End of day report:: ${branch.name} Retail Outlet`;
    });
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  beforeDestroy() {},
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  methods: {
    getTankSales() {
      this.tankSalesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankSales/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tankSalesLoader = false;
          let tankSale = response.data;
          this.tankSale.pms = tankSale
            .filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product1
            )
            .reduce((acc, curr) => {
              return acc + curr.volumeSold;
            }, 0);

          this.tankSale.ago = tankSale
            .filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product2
            )
            .reduce((acc, curr) => {
              return acc + curr.volumeSold;
            }, 0);

          this.tankSale.dpk = tankSale
            .filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product3
            )
            .reduce((acc, curr) => {
              return acc + curr.volumeSold;
            }, 0);

          this.tankSale.lpg = tankSale
            .filter(
              (prod) =>
                prod.productName.toLowerCase() ==
                this.countryProducts.productsLower.product4
            )
            .reduce((acc, curr) => {
              return acc + curr.volumeSold;
            }, 0);
        })
        .catch((error) => {
          this.tankSalesLoader = false;
        });
    },
    getPumpSales() {
      this.pumpSalesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DaySale/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.pumpSalesLoader = false;
          response.data.forEach((el) => {
            this.availableProducts.push(el.product.toLowerCase());
          });
          let dateOpened;
          let dateClosed;
          if (response.data.length > 0) {
            dateOpened = response.data.filter(
              (prod) => prod.dateOpened !== null
            );
            if (dateOpened.length) {
              dateOpened = dateOpened.sort((a, b) => {
                return new Date(b.dateOpened) - new Date(a.dateOpened);
              })[0].dateOpened;
            } else {
              dateOpened = null;
            }

            dateClosed = response.data.filter(
              (prod) => prod.dateModified !== null
            );
            if (dateClosed.length) {
              dateClosed = dateClosed.sort((a, b) => {
                return new Date(b.dateModified) - new Date(a.dateModified);
              })[0].dateModified;
            } else {
              dateClosed = null;
            }
          }
          this.operatingPeriod = "";
          if (
            dateOpened !== null &&
            dateOpened !== undefined &&
            dateClosed !== null &&
            dateClosed !== undefined
          ) {
            let diff =
              new Date(dateClosed).getTime() - new Date(dateOpened).getTime();
            let hr = Math.floor(diff / 1000 / 60 / 60);
            //let hr = diff_as_date.getHours() - 1; // hours
            this.operatingPeriod = `${this.$t(
              "text.endOfDayReport.operatingHours"
            )}: ${this.$moment(dateOpened).format("hh:mm A")} - ${this.$moment(
              dateClosed
            ).format("hh:mm A")} (${hr} ${this.$t(
              "text.endOfDayReport.hours"
            )})`;
          } else {
            this.operatingPeriod = `${this.$t(
              "text.endOfDayReport.operatingHours"
            )}: (0 ${this.$t("text.endOfDayReport.hours")})`;
          }

          this.displayData(response.data);
          this.paintGuageChart(response.data);
          this.productSummaryTable(response.data);
        })
        .catch((error) => {
          this.pumpSalesLoader = false;
        });
    },
    getExpenses() {
      this.expenseLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Expenses/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.expenseLoader = false;
          localStorage.setItem("expenses", JSON.stringify(response.data));
          this.expense = response.data.reduce((acc, curr) => {
            return acc + curr.amount;
          }, 0);
        })
        .catch((error) => {
          this.expenseLoader = false;
        });
    },
    getBankTrans() {
      this.cashToBankLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/BankTransaction/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.cashToBankLoader = false;
          localStorage.setItem(
            "bankTransactions",
            JSON.stringify(response.data)
          );
          let sum = 0;

          // Iterate through the array and add amounts if isConfirmed is true
          response.data.forEach((item) => {
            if (item.confirmed) {
              sum += item.amount;
            }
          });
          this.cashToBank = sum;
          // this.cashToBank = response.data.reduce((acc, curr) => {
          //   return acc + curr.amount;
          // }, 0);
        })
        .catch((error) => {
          this.cashToBankLoader = false;
        });
    },
    getPOSTransactions() {
      this.posTransactionLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/TransactionSummary/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.posTransactionLoader = false;
          this.posValue = response.data;
        })
        .catch((error) => {
          this.posTransactionLoader = false;
        });

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/TransactionSummary/${
            this.branchId
          }?startDate=${this.startDate}&endDate=${
            this.endDate
          }&product=${"pms"}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.pmsPosSale = response.data;
        })
        .catch((error) => {});

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/TransactionSummary/${
            this.branchId
          }?startDate=${this.startDate}&endDate=${
            this.endDate
          }&product=${"ago"}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.agoPosSale = response.data;
        })
        .catch((error) => {});

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/TransactionSummary/${
            this.branchId
          }?startDate=${this.startDate}&endDate=${
            this.endDate
          }&product=${"dpk"}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.dpkPosSale = response.data;
        })
        .catch((error) => {});

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/TransactionSummary/${
            this.branchId
          }?startDate=${this.startDate}&endDate=${
            this.endDate
          }&product=${"lpg"}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.lpgPosSale = response.data;
        })
        .catch((error) => {});
    },
    getPosVoucherSales() {
      this.posVoucherLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/POSandVoucherSales/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let products = [];
          response.data.forEach((item) => {
            products.push(item.productName);
            products.filter((product) => {
              if (product == item.productName) {
                this.newTableData[product.toLowerCase()] = {};

                // GETTING THE TOTAL VOLUME OF EACH PRODUCT FOR THE VOLUME GRAPH
                this.newTableData[product.toLowerCase()].totalEsaleVolume =
                  item.volSoldCard +
                  item.volSoldPOS +
                  // item.volSoldPhone +
                  item.volSoldRemis +
                  item.volSoldRetainership +
                  // item.volSoldSwipeCard +
                  item.volSoldUSSD +
                  item.volSoldVoucher +
                  item.volSoldCard +
                  item.volumeSoldMobileMoney;
                // amountSoldCard;
                // ussdAmount;
                //GROUPING EACH ESALES AMOUNT TO THEIR RESPECTIVE PRODUCTS

                // this.newTableData[product.toLowerCase()].swipeCardAmount =
                //   item.amountSoldSwipeCard;

                // this.newTableData[product.toLowerCase()].phoneAmount =
                //   item.amountSoldPhone;

                this.newTableData[product.toLowerCase()].totalCashSales =
                  item.amountSoldAttendant;
                this.newTableData[product.toLowerCase()].mobileMoneyAmount =
                  item.amountSoldMobileMoney;
                this.newTableData[product.toLowerCase()].POSAmount =
                  item.amountSoldPOS;

                this.newTableData[product.toLowerCase()].remisAmount =
                  item.amountSoldRemis;

                this.newTableData[product.toLowerCase()].retainershipAmount =
                  item.amountSoldRetainership;

                this.newTableData[product.toLowerCase()].ussdAmount =
                  item.amountSoldUSSD;

                this.newTableData[product.toLowerCase()].offlineSales =
                  item.amountSoldOffline;

                this.newTableData[product.toLowerCase()].voucherAmount =
                  item.amountSoldVoucher;

                this.newTableData[product.toLowerCase()].cardAmount =
                  item.amountSoldCard;

                this.newTableData[product.toLowerCase()].eSalesTotalAmount =
                  // item.amountSoldSwipeCard +
                  // item.amountSoldPhone +
                  item.amountSoldMobileMoney +
                  item.amountSoldPOS +
                  item.amountSoldRemis +
                  item.amountSoldRetainership +
                  item.amountSoldUSSD +
                  item.amountSoldVoucher +
                  item.amountSoldCard;
              }
            });
          });

          // MAPPING ESALES GRAPH BREAKDOWN
          let a = this.newTableData.ago
            ? this.newTableData.ago.totalEsaleVolume
            : 0;
          let d = this.newTableData.dpk
            ? this.newTableData.dpk.totalEsaleVolume
            : 0;
          let p = this.newTableData.pms
            ? this.newTableData.pms.totalEsaleVolume
            : 0;
          let l = this.newTableData.lpg
            ? this.newTableData.lpg.totalEsaleVolume
            : 0;

          // ALL ESALE AMOUNT

          let agoTotalEsales = this.newTableData.ago
            ? this.newTableData.ago.eSalesTotalAmount
            : 0;
          let dpkTotalEsales = this.newTableData.dpk
            ? this.newTableData.dpk.eSalesTotalAmount
            : 0;
          let pmsTotalEsales = this.newTableData.pms
            ? this.newTableData.pms.eSalesTotalAmount
            : 0;
          let lpgTotalEsales = this.newTableData.lpg
            ? this.newTableData.lpg.eSalesTotalAmount
            : 0;

          this.newTableData.allEsales =
            agoTotalEsales + dpkTotalEsales + pmsTotalEsales + lpgTotalEsales;

          this.donutSeries2 = [a, d, p, l];
          this.chartOptions2 = {
            ...this.chartOptions,
            labels: [
              this.countryProducts.products.product2,
              this.countryProducts.products.product3,
              this.countryProducts.products.product1,
              this.countryProducts.products.product4,
            ],
          };

          this.posVoucherLoader = false;
          let pos_voucher = response.data;

          this.pos_voucher.retainership = pos_voucher.reduce((acc, curr) => {
            return acc + curr.amountSoldRetainership;
          }, 0);

          this.pos_voucher.voucher = pos_voucher.reduce((acc, curr) => {
            return acc + curr.amountSoldVoucher;
          }, 0);

          let vouchSale = pos_voucher.filter(
            (prod) =>
              prod.productName.toLowerCase() ===
              this.countryProducts.productsLower.product1
          );
          this.pmsVoucher.epump = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldVoucher;
          }, 0);

          this.pmsVoucher.retainership = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldRetainership;
          }, 0);

          vouchSale = pos_voucher.filter(
            (prod) =>
              prod.productName.toLowerCase() ===
              this.countryProducts.productsLower.product2
          );
          this.agoVoucher.epump = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldVoucher;
          }, 0);

          this.agoVoucher.retainership = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldRetainership;
          }, 0);

          vouchSale = pos_voucher.filter(
            (prod) =>
              prod.productName.toLowerCase() ===
              this.countryProducts.productsLower.product3
          );
          this.dpkVoucher.epump = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldVoucher;
          }, 0);

          this.dpkVoucher.retainership = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldRetainership;
          }, 0);

          vouchSale = pos_voucher.filter(
            (prod) =>
              prod.productName.toLowerCase() ===
              this.countryProducts.productsLower.product4
          );
          this.lpgVoucher.epump = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldVoucher;
          }, 0);

          this.lpgVoucher.retainership = vouchSale.reduce((acc, curr) => {
            return acc + curr.amountSoldRetainership;
          }, 0);
        })
        .catch((error) => {
          this.posVoucherLoader = false;
        });
    },
    displayData(pumpSale) {
      this.pumpSale.pms = pumpSale
        .filter(
          (sl) =>
            sl.product !== null &&
            sl.product.toLowerCase() ===
              this.countryProducts.productsLower.product1
        )
        .reduce((acc, currValue) => {
          return acc + currValue.volume;
        }, 0);

      this.pumpSale.ago = pumpSale
        .filter(
          (sl) =>
            sl.product !== null &&
            sl.product.toLowerCase() ===
              this.countryProducts.productsLower.product2
        )
        .reduce((acc, currValue) => {
          return acc + currValue.volume;
        }, 0);

      this.pumpSale.dpk = pumpSale
        .filter(
          (sl) =>
            sl.product == this.countryProducts.productsLower.product3 ||
            sl.product == this.countryProducts.products.product3
        )
        .reduce((acc, currValue) => {
          return acc + currValue.volume;
        }, 0);

      this.pumpSale.lpg = pumpSale
        .filter(
          (sl) =>
            sl.product !== null &&
            sl.product.toLowerCase() ===
              this.countryProducts.productsLower.product4
        )
        .reduce((acc, currValue) => {
          return acc + currValue.volume;
        }, 0);

      this.totalSale = pumpSale.reduce((acc, curr) => {
        return acc + curr.amount;
      }, 0);

      this.rttAmount = pumpSale.reduce((acc, curr) => {
        return acc + curr.rttAmount;
      }, 0);
    },
    paintGuageChart(pumpSale) {
      let total = pumpSale.reduce((acc, curr) => {
        return acc + curr.volume;
      }, 0);

      let p = parseFloat(
        this.decimalThousand((this.pumpSale.pms / total) * 100)
      );
      let a = parseFloat(
        this.decimalThousand((this.pumpSale.ago / total) * 100)
      );
      let d = parseFloat(
        this.decimalThousand((this.pumpSale.dpk / total) * 100)
      );
      let l = parseFloat(
        this.decimalThousand((this.pumpSale.lpg / total) * 100)
      );

      this.donutSeries = [a, d, p, l];
      this.chartOptions = {
        ...this.chartOptions,
        labels: [
          this.countryProducts.products.product2,
          this.countryProducts.products.product3,
          this.countryProducts.products.product1,
          this.countryProducts.products.product4,
        ],
      };
    },

    productSummaryTable(pumpSale) {
      //PMS
      let summary = pumpSale.filter(
        (prod) =>
          prod.product.toLowerCase() ===
          this.countryProducts.productsLower.product1
      );

      this.pmsSummary = {
        volume: summary.reduce((acc, curr) => {
          return acc + curr.volume;
        }, 0),
        amount: summary.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0),
        rtt: summary.reduce((acc, curr) => {
          return acc + curr.rtt;
        }, 0),
        rttAmount: summary.reduce((acc, curr) => {
          return acc + curr.rttAmount;
        }, 0),
      };
      //AGO
      summary = pumpSale.filter(
        (prod) =>
          prod.product.toLowerCase() ===
          this.countryProducts.productsLower.product2
      );
      this.agoSummary = {
        volume: summary.reduce((acc, curr) => {
          return acc + curr.volume;
        }, 0),
        amount: summary.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0),
        rtt: summary.reduce((acc, curr) => {
          return acc + curr.rtt;
        }, 0),
        rttAmount: summary.reduce((acc, curr) => {
          return acc + curr.rttAmount;
        }, 0),
      };

      //DPK
      summary = pumpSale.filter(
        (prod) =>
          prod.product.toLowerCase() ===
          this.countryProducts.productsLower.product3
      );
      this.dpkSummary = {
        volume: summary.reduce((acc, curr) => {
          return acc + curr.volume;
        }, 0),
        amount: summary.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0),
        rtt: summary.reduce((acc, curr) => {
          return acc + curr.rtt;
        }, 0),
        rttAmount: summary.reduce((acc, curr) => {
          return acc + curr.rttAmount;
        }, 0),
      };
      //LPG
      summary = pumpSale.filter(
        (prod) =>
          prod.product.toLowerCase() ===
          this.countryProducts.productsLower.product4
      );
      this.lpgSummary = {
        volume: summary.reduce((acc, curr) => {
          return acc + curr.volume;
        }, 0),
        amount: summary.reduce((acc, curr) => {
          return acc + curr.amount;
        }, 0),
        rtt: summary.reduce((acc, curr) => {
          return acc + curr.rtt;
        }, 0),
        rttAmount: summary.reduce((acc, curr) => {
          return acc + curr.rttAmount;
        }, 0),
      };
    },
    getAllReports() {
      this.getPumpSales();
      this.getTankSales();
      this.getPosVoucherSales();
      this.getExpenses();
      this.getBankTrans();
      this.getPOSTransactions();
    },
    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
